define([
	"dojo/_base/declare",
	"dojo/topic",
	"csi",
	"csi/_base/underscore",
	"csi/action/Controller",
	"csi/comm",
	"csi/locale",
	"csi/monitor/_base",
], function(declare,topic,csi,_,Controller,comm,locale,monitor) {

	return declare(Controller, {
		// Boolean: wait for PDF to be generated before completing action
		bWait: true,

		// String: url of PDFRequest
		urlRequest: null,

		// String: status message
		message: null,

		// Number: number in milliseconds to wait before checking PDF request status
		waitDelay: 5000,

		// used for reporting progress
		_monitorHandle: null,
		_nTimeouts: 1,
		_stateLast: "Pending",

		getStringParameters: function() {
			return [locale.resource(this._stateLast.toLowerCase())];
		},

		getSuccess: function() {
			return this.message ? this.message : this.inherited(arguments);
		},

		getError: function() {
			return this.message ? this.message : this.inherited(arguments);
		},

		postProcessSuccess: function() {
			// summary: wait for PDF request to be processed if created successfully
			this.inherited(arguments);

			if (this.bWait) {
                this._monitorHandle = monitor.onChangeNode(this.urlRequest, node => this._postProcessPdf(node));
				_.delay(function(s) { topic.publish("/csi/dfd/progress", s); }, 100, this.getMessage());
			}
		},

		_createRequestUrl: function() {
			// summary: create url for PDFRequest
			this.urlRequest = comm.createUrl();
			return this.urlRequest;
		},

		_postProcessComplete: function(/*Node*/pdfRequest, /*Boolean*/bStatus) {
			// summary: called when _postProcessPdf detects pdf is complete
			topic.publish("/csi/pdf/complete", pdfRequest, bStatus);
		},

		_postProcessPdf: function(/*Node*/node) {
			// summary: query again for pdf request to determine current status; return true if finished
			if (node) {
				var	message = node.StatusMessage;
				var	state = node.Status;

				if (state == "Succeeded") {
					// notify others of success and open PDF file in new window
				    this._monitorHandle.remove();
					this.message = message;
					this._postProcessComplete(node, true);
					topic.publish("/csi/message/success", message);

					csi.browserWindow(comm.getFileHref(node.File, false, node.FileName));

					return;
				} else if (state == "Failed") {
					// request failed, so show error
					this.message = message;
				} else if (++this._nTimeouts >= 75) {
					// do not keep sending request if it has been more than 5 minutes
					this.message = this.getString("_Timeout");
				} else {
					// keep waiting - if status changes, then update progress message
					if (state != this._stateLast) {
						this._stateLast = state;
						topic.publish("/csi/message/progress", this.getMessage());
					}

					return;
				}
			}

			// notify others of error
            this._monitorHandle.remove();
			this._postProcessComplete(node, false);
			Controller.prototype.postProcess.call(this, false, false);
		}
	});
});